import React from 'react';
import { Popover as BasePopover, PopoverProps as BasePopoverProps } from 'antd';

export type PopoverProps = BasePopoverProps & {};

const Popover: React.FC<PopoverProps> = ({ ...props }) => <BasePopover {...props} />;

export default Popover;